import React from 'react';
import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

const Avatar = ({ children, className, img, img2x, initials }) => (
  <span className={className}>
    {!img && !img2x && initials}
    {children}
  </span>
);

const backgroundColor = ({ deactivated, lightBackground }) => {
  if (lightBackground) {
    return deactivated ? colors.N30 : colors.N40;
  } else {
    return deactivated ? colors.N20 : colors.N40;
  }
};

const lineHeight = ({ lightBackground, size }) => {
  if (lightBackground) {
    return `${size ? size - 2 : '26'}px`;
  } else {
    return `${size ? size : '28'}px`;
  }
};

export default styled(Avatar)`
  align-items: center;
  background-color: ${backgroundColor};
  ${({ img }) =>
    img
      ? `background-image: url(${img});`
      : ''} background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border: ${({ lightBackground }) =>
    lightBackground ? `solid 1px ${colors.N40}` : '0'};
  border-radius: 100%;
  box-sizing: border-box;
  color: ${({ deactivated }) => (deactivated ? colors.N200 : colors.N800)}};
  display: inline-flex;
  font-family: ${fontFamily};
  font-size: ${({ initials }) => {
    switch (initials && initials.length) {
      case 4:
        return 9;
      case 3:
        return 11;
      case 2:
      default:
        return 12;
    }
  }}px;
  font-weight: bold;
  justify-content: center;
  line-height: ${lineHeight};
  height: ${({ size }) => size || '28'}px;
  width: ${({ size }) => size || '28'}px;
  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),
    only screen and (-moz-min-device-pixel-ratio: 1.5),
    only screen and (-o-min-device-pixel-ratio: 3/2),
    only screen and (min-resolution: 1.5dppx) {
    ${({ img2x }) => (img2x ? `background-image: url(${img2x});` : '')};
  }

  ${({ deactivated, img }) => deactivated && img && 'opacity: 0.2;'};
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/shared/Avatar.js